var policy;
__webpack_require__.tu = (url) => {
	// Create Trusted Type policy if Trusted Types are available and the policy doesn't exist yet.
	if (policy === undefined) {
		policy = {
			createScriptURL: (url) => (url)
		};
		if (typeof trustedTypes !== "undefined" && trustedTypes.createPolicy) {
			policy = trustedTypes.createPolicy("angular#bundler", policy);
		}
	}
	return policy.createScriptURL(url);
};